// src/pages/PaymentOptionsPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentOptionsPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const SectionTitle = ({ children }) => (
    <h2 className="text-xl font-black text-[#0F2F63] mt-8 mb-4 border-b border-gray-100 pb-2">
      {children}
    </h2>
  );

  const BulletPoint = ({ children }) => (
    <li className="flex items-start mb-2.5">
      <span className="text-[#FF7A59] mr-3 mt-1.5"><i className="fas fa-circle text-[6px]"></i></span>
      <span className="text-gray-600 font-medium leading-relaxed flex-1">{children}</span>
    </li>
  );

  return (
    <div className="py-6 px-4 md:px-8 max-w-4xl mx-auto w-full min-h-[70vh] animate-fade-in">
      <div className="flex items-center gap-4 mb-6 border-b border-gray-100 pb-5">
        <button 
          onClick={() => navigate(-1)} 
          className="w-10 h-10 rounded-full bg-white shadow-sm border border-gray-200 hover:bg-gray-50 flex items-center justify-center text-gray-600 transition-colors"
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="text-2xl md:text-3xl font-black text-[#0F2F63] flex items-center gap-3">
          <i className="fas fa-credit-card text-[#FF7A59]"></i> Payment Options
        </h1>
      </div>

      <div className="bg-white p-6 md:p-10 rounded-3xl shadow-sm border border-gray-100">
        <SectionTitle>1. Secure Online Payments</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          SV MART uses Razorpay, India's leading highly secure payment gateway, to process all digital transactions. We accept a wide variety of online payment methods:
        </p>
        <ul className="mb-4">
          <BulletPoint><strong className="text-gray-800">UPI:</strong> Google Pay, PhonePe, Paytm, BHIM, and other UPI apps.</BulletPoint>
          <BulletPoint><strong className="text-gray-800">Credit & Debit Cards:</strong> Visa, MasterCard, RuPay, and Maestro.</BulletPoint>
          <BulletPoint><strong className="text-gray-800">Net Banking:</strong> All major Indian banks are supported.</BulletPoint>
          <BulletPoint><strong className="text-gray-800">Wallets:</strong> Amazon Pay, Mobikwik, Freecharge, etc.</BulletPoint>
        </ul>

        <SectionTitle>2. Cash on Delivery (COD)</SectionTitle>
        <ul className="mb-4">
          <BulletPoint>We offer Cash on Delivery for most locations to allow you to pay upon receiving your items.</BulletPoint>
          <BulletPoint>A nominal convenience charge may apply for COD orders, which will be visible on the checkout page.</BulletPoint>
          <BulletPoint>Please keep exact change ready for a smoother delivery experience.</BulletPoint>
        </ul>

        <SectionTitle>3. Payment Security</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          Your security is our priority. We do not store your sensitive payment information like CVV or card numbers on our servers. All transactions are encrypted with PCI-DSS compliant technology through our payment partners.
        </p>

        <SectionTitle>4. Payment Failures</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          If your account is debited but the order is not placed due to a technical error, the amount is automatically refunded by the payment gateway to your original payment method within 3-5 business days.
        </p>
      </div>
    </div>
  );
};

export default PaymentOptionsPage;